import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-dialog-user-name',
    template: require('./dialogUsername.html')
})
export class DialogUserNameComponent {

    constructor(public dialogRef: MatDialogRef<DialogUserNameComponent>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}
